/*eslint no-undef: 0*/

import { fetchFromApi } from '../../helpers/api';

export const AuthActionTypes = {
  LOGIN_REQUEST: 'AUTH/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'AUTH/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'AUTH/LOGIN_FAILURE',
  LOGOUT: 'AUTH/LOGOUT',
  USER_LOAD_REQUEST: 'AUTH/USER_LOAD_REQUEST',
  USER_LOAD_SUCCESS: 'AUTH/USER_LOAD_SUCCESS',
  USER_LOAD_FAILURE: 'AUTH/USER_LOAD_FAILURE',
  FORGOT_PASSWORD_REQUEST: 'AUTH/FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'AUTH/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'AUTH/FORGOT_PASSWORD_FAILURE',
  SHOW_LOGIN_MODAL: 'AUTH/SHOW_LOGIN_MODAL',
  SHOW_CHANGE_PASSWORD_MODAL: 'AUTH/SHOW_CHANGE_PASSWORD_MODAL',
  CHANGE_PASSWORD_REQUEST: 'AUTH/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'AUTH/CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'AUTH/CHANGE_PASSWORD_FAILURE'
};

/**
 *
 * @param {string} username
 * @param {string }password
 * @returns {Object}
 */
export function login(email, password) {
  // Lowercase username (email)
  // We use this format to get post data in request.POST on backend (having data in request.body is insufficient)
  const body = `email=${email.toLowerCase()}&password=${password}&client=${true}`;

  const headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded');

  const init = {
    method: 'POST',
    headers,
    body
  };

  return {
    types: [
      AuthActionTypes.LOGIN_REQUEST,
      AuthActionTypes.LOGIN_SUCCESS,
      AuthActionTypes.LOGIN_FAILURE
    ],
    shouldCallApi: state => !state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('client-api/login/', init, dispatch)
  };
}

export function forgotPassword(email) {
  const body = { email };
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const init = {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  };

  return {
    types: [
      AuthActionTypes.FORGOT_PASSWORD_REQUEST,
      AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
      AuthActionTypes.FORGOT_PASSWORD_FAILURE
    ],
    shouldCallApi: state => !state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('client-api/reset/', init, dispatch)
  };
}

export function showChangePasswordModal(show) {
  return {
    type: AuthActionTypes.SHOW_CHANGE_PASSWORD_MODAL,
    show
  };
}

export function showLoginModal(show) {
  return {
    type: AuthActionTypes.SHOW_LOGIN_MODAL,
    show
  };
}

export function changePassword(formData) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const init = {
    method: 'POST',
    headers,
    body: JSON.stringify(formData)
  };

  return {
    types: [
      AuthActionTypes.CHANGE_PASSWORD_REQUEST,
      AuthActionTypes.CHANGE_PASSWORD_SUCCESS,
      AuthActionTypes.CHANGE_PASSWORD_FAILURE
    ],
    shouldCallApi: state => state.auth.get('isAuthenticated'),
    callApi: dispatch =>
      fetchFromApi('client-api/change-password/', init, dispatch)
  };
}

/**
 *
 * @returns {Object}
 */
export function loadUser() {
  return {
    types: [
      AuthActionTypes.USER_LOAD_REQUEST,
      AuthActionTypes.USER_LOAD_SUCCESS,
      AuthActionTypes.USER_LOAD_FAILURE
    ],
    shouldCallApi: state => true,
    callApi: dispatch =>
      fetchFromApi('client-api/profile/', { method: 'GET' }, dispatch)
  };
}

/**
 *
 * @returns {Object}
 */
export function logout() {
  return { type: AuthActionTypes.LOGOUT };
}



/** WEBPACK FOOTER **
 ** ./src/state/auth/actions.js
 **/